<ng-container *transloco="let t; read: 'basket-offline'">
    <section class="xs12col componentHeader">
        <h1>{{t('title')}}</h1>
    </section>
    <ng-container>
        <section class="oneCol">
            <div class="xs12col">
                <div class="boxContainer">
                    <div class="box">
                        <app-offline-basket
                            [currentCompany]="currentCompany$ | async">
                        </app-offline-basket>
                    </div>
                </div>
            </div>
        </section>
    </ng-container>
</ng-container>